export const model = {
    id: null,
    name: '',
    slug: '',
    created_at: "",
    updated_at: ''
};
